export default {
  section_title: 'Valuutta',
  label: 'Valuutta',
  tooltip:
    'Valuutta, jota hinnat, tilitykset ja raportit käyttävät. Se asetetaan kumppanitilillesi sen luomisen yhteydessä, eikä sitä voi muuttaa täällä — ota yhteyttä tukeen, jos se on väärä.',
  from_your_partner: 'Kumppaniltasi',
  set_for_your_account: 'Asetettu tilillesi',
};
